module.exports = __webpack_public_path__ + "img/prince.c962d1c9.jpg";